import React from 'react'
import { Field, reduxForm } from 'redux-form'
import { compose } from 'redux'
import { useTranslation } from 'react-i18next'
import { Button } from 'reactstrap'

import renderField from 'Containers/Validation/renderField'
import validate from 'Containers/Validation/validate'

const ForgotPasswordForm = ({ handleSubmit }) => {
  const { t } = useTranslation()

  return (
    <form className="form login-form" onSubmit={handleSubmit}>
      <div className="form__form-group">
        <div className="form__form-group-field">
          <div className="form__form-group-field">
            <Field
              component={renderField}
              name="email"
              placeholder={t('login.email')}
              type="email"
            />
          </div>
        </div>
      </div>
      <Button
        color="btn btn-success account__btn account__btn--small"
        type="submit"
      >
        {t('forgotPasswordPage.resetPassword')}
      </Button>
    </form>
  )
}

export default compose(
  reduxForm({
    form: 'forgot_password_form',
    validate,
  })
)(ForgotPasswordForm)
